import React from "react";
import QaiChallengeContainer from "../Shared/QaiChallengeContainer";

export default function QaQaiChallengeContainer() {
    return (
        <QaiChallengeContainer view="QA" />
    )
}